import startCase from 'lodash.startcase'

export default (node) => {
  $('#hover-node-card .card-header').text(node.name)
  
  const userInputFlowIdValue = node.data.userInputFlowIdValue || ''
  const userInputFlowIdText = node.data.userInputFlowIdText || ''
  const delayReplyFor = node.data.delayReplyFor || ''
  const IsTypingOnDisplayChecked = node.data.IsTypingOnDisplayChecked || false
  
  if (! userInputFlowIdValue) {
    $('#hover-node-card .card-body').html('')
  } else {
    const studlyCasedUserInputFlowIdText = startCase(userInputFlowIdText)
    let html = `<p><strong>Input flow ID:</strong> ${studlyCasedUserInputFlowIdText}</p>`
    if (IsTypingOnDisplayChecked && delayReplyFor) {
      html += `<p><strong>Delay in reply:</strong> ${delayReplyFor} second(s)</p>`
    }

    $('#hover-node-card .card-body').html(html)
  }
}